function inicializarScripts() {

    function initSwiperSliders() {
        // Slider principal da página de imóvel
        const gallerySlider = document.querySelector('.imovel-gallery-slider');
        if (gallerySlider) {
            new Swiper(gallerySlider, {
                slidesPerView: 1,
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    768: { slidesPerView: 2, },
                    992: { slidesPerView: 3, }
                }
            });
        }

        // Slider para imóveis similares
        const similaresSlider = document.querySelector('.similar-imoveis-slider');
        if (similaresSlider) {
            new Swiper(similaresSlider, {
                spaceBetween: 30,
                slidesPerView: 1,
                watchOverflow: true,
                loop: false,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    768: { slidesPerView: 2 },
                    992: { slidesPerView: 3 }
                }
            });
        }

        // Slider para imóveis em destaque na home
        const destaqueSlider = document.querySelector('.imoveis-destaque-slider');
        if (destaqueSlider) {
            new Swiper(destaqueSlider, {
                spaceBetween: 30,
                slidesPerView: 1,
                watchOverflow: true,
                loop: false,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    768: { slidesPerView: 2 },
                    992: { slidesPerView: 3 }
                }
            });
        }
    }

    // Chama a função que inicia os sliders
    initSwiperSliders();
}


window.addEventListener('load', inicializarScripts);
